<template>
  <div class="wrap">
    <img class="bg-img"
      src="https://hzwimspic-1251601690.image.myqcloud.com/a8e02646-290a-4c00-b7f6-85f68c032d54_size_1125x627" />
    <!-- 新增：宝宝信息卡片 -->
    <div class="baby-info-card">
      <div class="baby-info-left">
        <img class="baby-avatar"
          src="https://hzwimspic-1251601690.image.myqcloud.com/434c88b7-02ea-4efc-81e4-cf21f136f6a8_size_240x240"
          alt="" />
      </div>
      <div class="baby-info-right">
        <div class="baby-title">
          <span>宝宝
            <img class="baby-gender"
              :src="+empInfo.sex === 2 ? 'https://hzwimspic-1251601690.image.myqcloud.com/e58cfd6f-22d0-49cb-b2ea-e282d3059cac_size_45x45' : 'https://hzwimspic-1251601690.image.myqcloud.com/1dd5bb08-a812-46b5-878c-e3a1eeda45cf_size_45x45'"
              alt="" srcset="">
          </span>
          <button class="unbind-btn" @click="alertUnbindOrder">解绑订单</button>
        </div>
        <div class="baby-detail">{{ `雇主手机号：${empInfo.mobile}` }}</div>
        <div class="baby-detail">{{ `服务订单号：${orderId}` }}</div>
      </div>
    </div>

    <!-- 新增：日期与上传记录区块 -->
    <div class="date-upload-bar">
      <span class="date-text" @click="showDateSheet = true">{{ formattedDate }} <img
          src="https://hzwimspic-1251601690.image.myqcloud.com/29949d27-ee55-44b9-8f5b-cb3833225619_size_28x18"
          alt=""></span>
      <span class="upload-record" @click="toServiceCalendar">上传记录 <img
          src="https://hzwimspic-1251601690.image.myqcloud.com/a58258b0-26db-4d75-a34a-7d4de75d1fe7_size_15x25"
          alt=""></span>
    </div>

    <!-- 新增：上传服务记录卡片 -->
    <div class="upload-card">
      <img v-if="logInfo.pics" class="bg-card"
        src="https://hzwimspic-1251601690.image.myqcloud.com/85fdfdee-0fbc-4db9-81a4-0f6de14758a1_size_328x88" alt="">
      <div v-if="!logInfo.pics" class="upload-plus">
        <img @click="toAddLog"
          src="https://hzwimspic-1251601690.image.myqcloud.com/536d7137-4fac-4777-897f-014d98f563f3_size_52x52" alt="">
      </div>
      <img v-else class="upload-pic" :src="logInfo.pics" alt="" />
      <div v-if="!logInfo.pics" class="upload-tip">上传今日服务记录</div>
      <img v-else class="upload-edit" @click="toAddLog"
        src="https://hzwimspic-1251601690.image.myqcloud.com/52e9f16b-e0c1-4e49-9798-3d2272708ba0_size_220x109"
        alt="" />
    </div>
    <van-popup v-model="showDateSheet" position="bottom">
      <van-datetime-picker v-model="dateModel" type="date" title="时间选择" :min-date="startTime" :max-date="endTime"
        :formatter="formatterDatePicker" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </div>
</template>

<script>
import { queryEmployerInfo, saveUnbindOrder, queryOrderData, queryYuesaoLogDetail } from '../service'
import dayjs from 'dayjs'
import { DatetimePicker, Popup } from 'vant';
import { Msgbox } from 'kf-component-vue'

export default {
  data() {
    return {
      orderId: '',
      empInfo: {},
      //当前日期 yyyy年mm月dd日
      startTime: new Date(),
      endTime: new Date(),
      logInfo: {},
      showDateSheet: false,
      currentDate: new Date(),
      dateModel: new Date(),
    }
  },
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  computed: {
    formattedDate() {
      return dayjs(this.currentDate).format('YYYY年MM月DD日')
    }
  },
  created() {
    this.$$title('电子日志')
    const { orderId = '' } = this.$route.query
    this.orderId = orderId
  },
  async mounted() {
    this.$$loading(true)
    queryEmployerInfo({ orderId: this.orderId }).then((res) => {
      this.$$loading(false)
      const { code, msg = '网络异常，请刷新重试', data = {} } = res
      if (+code == 10) {
        this.$$toast(msg)
        this.$router.replace('/yuesao-serve/bind-order')
      } else {
        this.empInfo = data || {}
      }
    }).catch((err) => {
      this.$$loading(false)
      this.$$toast(err)
    })
    this.queryLog()

    queryOrderData({ orderId: this.orderId }).then((res) => {
      this.startTime = new Date(res.confirmHouseholdTime)
      // this.endTime = new Date(res.endDate)
    }).catch((err) => {
      this.$$toast(err)
    })

  },
  methods: {
    onConfirm(value, index) {
      this.currentDate = value
      this.showDateSheet = false
      this.queryLog()
    },
    onCancel() {
      this.showDateSheet = false
    },

    formatterDatePicker(type, val) {
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },

    alertUnbindOrder() {
      Msgbox({
        title: '',
        message: '确定解绑订单吗?',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'confirm',
        action: msgbox => {
          this.unbindOrder()
        }
      })
    },

    unbindOrder() {
      this.$$loading(true)
      saveUnbindOrder({ orderId: this.orderId }).then(() => {
        this.$$loading(false)
        this.$router.replace('/yuesao-serve/bind-order')
      }).catch((err) => {
        this.$$loading(false)
        this.$$toast(err)
      })
    },

    queryLog() {
      this.$$loading(true)
      const logDate = dayjs(this.currentDate).format('YYYY-MM-DD');
      queryYuesaoLogDetail({ orderId: this.orderId, logDate: logDate }).then((res) => {
        this.$$loading(false)
        // 处理返回的数据
        this.logInfo = res || {}
      }).catch((err) => {
        this.logInfo = {}
        this.$$loading(false)
        this.$$toast(err)
      })
    },

    toServiceCalendar() {
      this.$router.push(`/yuesao-serve/service-calendar?orderId=${this.orderId}`)
    },
    toAddLog() {
      this.$router.push(`/yuesao-serve/add-log?orderId=${this.orderId}&logDate=${dayjs(this.currentDate).format('YYYY-MM-DD')}`)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.wrap {
  background-color: #f4f4f4;
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: rem(750px);
  height: rem(418px);
}

.baby-info-card {
  display: flex;
  height: rem(294px);
  position: relative;
}

.baby-info-left {
  margin-right: rem(30px);
  margin-left: rem(32px);
  margin-top: rem(54px);
}

.baby-avatar {
  width: rem(160px);
  height: rem(160px);
  border-radius: 50%;
  background: #fff;
}

.baby-info-right {
  flex: 1;
}

.baby-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: rem(62px);
  align-items: center;
  font-size: rem(34px);
  font-weight: bold;
  color: #262626;
}

.baby-gender {
  margin-left: rem(12px);
  width: rem(30px);
  height: rem(30px);
}

.unbind-btn {
  margin-right: rem(28px);
  width: rem(144px);
  height: rem(52px);
  mix-blend-mode: normal;
  border-radius: rem(26px);
  background: rgba(255, 255, 255, 0.6);
  color: #121212;
  font-weight: 400;
  font-size: rem(24px);
}

.baby-detail {
  font-size: rem(24px);
  color: #666;
  margin-top: rem(20px);

}

.baby-detail:last-child {
  margin-top: rem(8px);
}

.date-upload-bar {
  display: flex;
  justify-content: space-between;
  position: absolute;
  padding: 0 rem(24px);
  top: rem(268px);
  left: 0px;
  width: rem(750px);
  height: rem(150px);
  border-radius: rem(26px);
  background: linear-gradient(180deg, #ffffff 0%, #f4f4f4 110.22%);
}

.date-text {
  margin-top: rem(34px);
  color: #121212;
  font-size: rem(32px);
  font-weight: 500;

  img {
    margin-left: rem(12px);
    width: rem(19px);
    height: rem(12px);
  }
}

.upload-record {
  margin-top: rem(37px);
  color: #666;
  font-size: rem(26px);

  img {
    margin-left: rem(12px);
    width: rem(10px);
    height: rem(17px);
  }
}

.upload-card {
  position: absolute;
  top: rem(388px);
  left: rem(24px);
  width: rem(702px);
  height: rem(440px);
  background: #fff;
  border-radius: rem(28px);
  padding: rem(32px) 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg-card {
  position: absolute;
  top: rem(136px);
  left: rem(187px);
  width: rem(328px);
  height: rem(88px);
}

.upload-plus {
  width: rem(160px);
  height: rem(160px);
  border: rem(2px) dashed #DEE5F4;
  border-radius: rem(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(137.81deg, #f5fbff -14.11%, #fbf5ff 94.34%);

  img {
    width: rem(80px);
    height: rem(80px);
  }
}

.upload-pic {
  width: rem(180px);
  height: rem(180px);
  border-radius: rem(20px);
}

.upload-tip {
  margin-top: rem(28px);
  font-size: rem(28px);
  color: #121212;
}

.upload-edit {
  margin-top: rem(18px);
  width: rem(122px);
  height: rem(54px);
  object-fit: cover;
}


/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ff397e;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: rem(28px);
}

/deep/ .van-ellipsis {
  color: #262626;
  font-size: rem(36px);
}
</style>
